/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTaskAttachmentDto,
  CreateTaskCommentDto,
  CreateTaskDto,
  DeletedResponseDto,
  MoveTaskDto,
  TaskAttachmentDto,
  TaskBoardDto,
  TaskCommentDto,
  TaskDetailDto,
  TasksControllerBoardV1Params,
  TasksControllerListTasksV1200,
  TasksControllerListTasksV1Params,
  UpdateTaskCommentDto,
  UpdateTaskDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTasksControllerListTasksV1Url = (params?: TasksControllerListTasksV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statusId","category","assigneeId","teamId","labelId","priority","creatorId"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tasks?${stringifiedParams}` : `/v1/tasks`
}

/**
 * Paginated and filterable. Each row carries `locked`, true while an earlier step of the same checklist is unfinished.
 * @summary List tasks
 */
export const tasksControllerListTasksV1 = async (params?: TasksControllerListTasksV1Params, options?: RequestInit): Promise<TasksControllerListTasksV1200> => {

  return apiRequest<TasksControllerListTasksV1200>(getTasksControllerListTasksV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTasksControllerListTasksV1QueryKey = (params?: TasksControllerListTasksV1Params,) => {
    return [
    `/v1/tasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getTasksControllerListTasksV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError = unknown>(params?: TasksControllerListTasksV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerListTasksV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerListTasksV1>>> = ({ signal }) => tasksControllerListTasksV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerListTasksV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerListTasksV1>>>
export type TasksControllerListTasksV1QueryError = unknown


export function useTasksControllerListTasksV1<TData = Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError = unknown>(
 params: undefined |  TasksControllerListTasksV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerListTasksV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerListTasksV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerListTasksV1<TData = Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError = unknown>(
 params?: TasksControllerListTasksV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerListTasksV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerListTasksV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerListTasksV1<TData = Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError = unknown>(
 params?: TasksControllerListTasksV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tasks
 */

export function useTasksControllerListTasksV1<TData = Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError = unknown>(
 params?: TasksControllerListTasksV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListTasksV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerListTasksV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerCreateTaskV1Url = () => {




  return `/v1/tasks`
}

/**
 * @summary Create a task
 */
export const tasksControllerCreateTaskV1 = async (createTaskDto: CreateTaskDto, options?: RequestInit): Promise<TaskDetailDto> => {

  return apiRequest<TaskDetailDto>(getTasksControllerCreateTaskV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskDto)
  }
);}





export const getTasksControllerCreateTaskV1QueryKey = (createTaskDto?: CreateTaskDto,) => {
    return [
    'POST', `/v1/tasks`, createTaskDto
    ] as const;
    }


export const getTasksControllerCreateTaskV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError = unknown>(createTaskDto: CreateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerCreateTaskV1QueryKey(createTaskDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>> = ({ signal }) => tasksControllerCreateTaskV1(createTaskDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerCreateTaskV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>>
export type TasksControllerCreateTaskV1QueryError = unknown


export function useTasksControllerCreateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError = unknown>(
 createTaskDto: CreateTaskDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerCreateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError = unknown>(
 createTaskDto: CreateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerCreateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError = unknown>(
 createTaskDto: CreateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a task
 */

export function useTasksControllerCreateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError = unknown>(
 createTaskDto: CreateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerCreateTaskV1QueryOptions(createTaskDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerBoardV1Url = (params?: TasksControllerBoardV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statusId","category","assigneeId","teamId","labelId","priority","creatorId"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tasks/board?${stringifiedParams}` : `/v1/tasks/board`
}

/**
 * Unpaginated (capped). The client groups by `status.id`; `truncated` says the cap was hit.
 * @summary Every task matching the filters, in column order
 */
export const tasksControllerBoardV1 = async (params?: TasksControllerBoardV1Params, options?: RequestInit): Promise<TaskBoardDto> => {

  return apiRequest<TaskBoardDto>(getTasksControllerBoardV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTasksControllerBoardV1QueryKey = (params?: TasksControllerBoardV1Params,) => {
    return [
    `/v1/tasks/board`, ...(params ? [params] : [])
    ] as const;
    }


export const getTasksControllerBoardV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError = unknown>(params?: TasksControllerBoardV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerBoardV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerBoardV1>>> = ({ signal }) => tasksControllerBoardV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerBoardV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerBoardV1>>>
export type TasksControllerBoardV1QueryError = unknown


export function useTasksControllerBoardV1<TData = Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError = unknown>(
 params: undefined |  TasksControllerBoardV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerBoardV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerBoardV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerBoardV1<TData = Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError = unknown>(
 params?: TasksControllerBoardV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerBoardV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerBoardV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerBoardV1<TData = Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError = unknown>(
 params?: TasksControllerBoardV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every task matching the filters, in column order
 */

export function useTasksControllerBoardV1<TData = Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError = unknown>(
 params?: TasksControllerBoardV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerBoardV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerBoardV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerGetTaskV1Url = (id: string,) => {




  return `/v1/tasks/${id}`
}

/**
 * @summary One task with its description and attachments
 */
export const tasksControllerGetTaskV1 = async (id: string, options?: RequestInit): Promise<TaskDetailDto> => {

  return apiRequest<TaskDetailDto>(getTasksControllerGetTaskV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTasksControllerGetTaskV1QueryKey = (id: string,) => {
    return [
    `/v1/tasks/${id}`
    ] as const;
    }


export const getTasksControllerGetTaskV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerGetTaskV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>> = ({ signal }) => tasksControllerGetTaskV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerGetTaskV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>>
export type TasksControllerGetTaskV1QueryError = unknown


export function useTasksControllerGetTaskV1<TData = Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerGetTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerGetTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerGetTaskV1<TData = Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerGetTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerGetTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerGetTaskV1<TData = Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One task with its description and attachments
 */

export function useTasksControllerGetTaskV1<TData = Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerGetTaskV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerUpdateTaskV1Url = (id: string,) => {




  return `/v1/tasks/${id}`
}

/**
 * Partial. `assigneeIds` and `labelIds` replace the set when sent. Moving a **locked** checklist step forward returns 409; reopening is always allowed.
 * @summary Update a task
 */
export const tasksControllerUpdateTaskV1 = async (id: string,
    updateTaskDto: UpdateTaskDto, options?: RequestInit): Promise<TaskDetailDto> => {

  return apiRequest<TaskDetailDto>(getTasksControllerUpdateTaskV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskDto)
  }
);}





export const getTasksControllerUpdateTaskV1QueryKey = (id: string,
    updateTaskDto?: UpdateTaskDto,) => {
    return [
    'PATCH', `/v1/tasks/${id}`, updateTaskDto
    ] as const;
    }


export const getTasksControllerUpdateTaskV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError = unknown>(id: string,
    updateTaskDto: UpdateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerUpdateTaskV1QueryKey(id,updateTaskDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>> = ({ signal }) => tasksControllerUpdateTaskV1(id,updateTaskDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerUpdateTaskV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>>
export type TasksControllerUpdateTaskV1QueryError = unknown


export function useTasksControllerUpdateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError = unknown>(
 id: string,
    updateTaskDto: UpdateTaskDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerUpdateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError = unknown>(
 id: string,
    updateTaskDto: UpdateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerUpdateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError = unknown>(
 id: string,
    updateTaskDto: UpdateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update a task
 */

export function useTasksControllerUpdateTaskV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError = unknown>(
 id: string,
    updateTaskDto: UpdateTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerUpdateTaskV1QueryOptions(id,updateTaskDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerDeleteTaskV1Url = (id: string,) => {




  return `/v1/tasks/${id}`
}

/**
 * Checklist steps cannot be deleted (409).
 * @summary Delete a task
 */
export const tasksControllerDeleteTaskV1 = async (id: string, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTasksControllerDeleteTaskV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTasksControllerDeleteTaskV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/tasks/${id}`
    ] as const;
    }


export const getTasksControllerDeleteTaskV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerDeleteTaskV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>> = ({ signal }) => tasksControllerDeleteTaskV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerDeleteTaskV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>>
export type TasksControllerDeleteTaskV1QueryError = unknown


export function useTasksControllerDeleteTaskV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerDeleteTaskV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerDeleteTaskV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a task
 */

export function useTasksControllerDeleteTaskV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerDeleteTaskV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerMoveTaskV1Url = (id: string,) => {




  return `/v1/tasks/${id}/move`
}

/**
 * Into a column, between two neighbours. 409 when the neighbours are no longer in that column — refetch the board.
 * @summary Drag-and-drop a task
 */
export const tasksControllerMoveTaskV1 = async (id: string,
    moveTaskDto: MoveTaskDto, options?: RequestInit): Promise<TaskDetailDto> => {

  return apiRequest<TaskDetailDto>(getTasksControllerMoveTaskV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(moveTaskDto)
  }
);}





export const getTasksControllerMoveTaskV1QueryKey = (id: string,
    moveTaskDto?: MoveTaskDto,) => {
    return [
    'POST', `/v1/tasks/${id}/move`, moveTaskDto
    ] as const;
    }


export const getTasksControllerMoveTaskV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError = unknown>(id: string,
    moveTaskDto: MoveTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerMoveTaskV1QueryKey(id,moveTaskDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>> = ({ signal }) => tasksControllerMoveTaskV1(id,moveTaskDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerMoveTaskV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>>
export type TasksControllerMoveTaskV1QueryError = unknown


export function useTasksControllerMoveTaskV1<TData = Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError = unknown>(
 id: string,
    moveTaskDto: MoveTaskDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerMoveTaskV1<TData = Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError = unknown>(
 id: string,
    moveTaskDto: MoveTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerMoveTaskV1<TData = Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError = unknown>(
 id: string,
    moveTaskDto: MoveTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drag-and-drop a task
 */

export function useTasksControllerMoveTaskV1<TData = Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError = unknown>(
 id: string,
    moveTaskDto: MoveTaskDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerMoveTaskV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerMoveTaskV1QueryOptions(id,moveTaskDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerAddAttachmentV1Url = (id: string,) => {




  return `/v1/tasks/${id}/attachments`
}

/**
 * Upload first with `POST /v1/uploads/presign` (scope `task-attachment`), then register the key here.
 * @summary Attach an uploaded file
 */
export const tasksControllerAddAttachmentV1 = async (id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options?: RequestInit): Promise<TaskAttachmentDto> => {

  return apiRequest<TaskAttachmentDto>(getTasksControllerAddAttachmentV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskAttachmentDto)
  }
);}





export const getTasksControllerAddAttachmentV1QueryKey = (id: string,
    createTaskAttachmentDto?: CreateTaskAttachmentDto,) => {
    return [
    'POST', `/v1/tasks/${id}/attachments`, createTaskAttachmentDto
    ] as const;
    }


export const getTasksControllerAddAttachmentV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError = unknown>(id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerAddAttachmentV1QueryKey(id,createTaskAttachmentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>> = ({ signal }) => tasksControllerAddAttachmentV1(id,createTaskAttachmentDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerAddAttachmentV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>>
export type TasksControllerAddAttachmentV1QueryError = unknown


export function useTasksControllerAddAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError = unknown>(
 id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerAddAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError = unknown>(
 id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerAddAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError = unknown>(
 id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attach an uploaded file
 */

export function useTasksControllerAddAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError = unknown>(
 id: string,
    createTaskAttachmentDto: CreateTaskAttachmentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerAddAttachmentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerAddAttachmentV1QueryOptions(id,createTaskAttachmentDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerRemoveAttachmentV1Url = (id: string,
    attachmentId: string,) => {




  return `/v1/tasks/${id}/attachments/${attachmentId}`
}

/**
 * @summary Remove an attachment
 */
export const tasksControllerRemoveAttachmentV1 = async (id: string,
    attachmentId: string, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTasksControllerRemoveAttachmentV1Url(id,attachmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTasksControllerRemoveAttachmentV1QueryKey = (id: string,
    attachmentId: string,) => {
    return [
    'DELETE', `/v1/tasks/${id}/attachments/${attachmentId}`
    ] as const;
    }


export const getTasksControllerRemoveAttachmentV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError = unknown>(id: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerRemoveAttachmentV1QueryKey(id,attachmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>> = ({ signal }) => tasksControllerRemoveAttachmentV1(id,attachmentId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && attachmentId !== null && attachmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerRemoveAttachmentV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>>
export type TasksControllerRemoveAttachmentV1QueryError = unknown


export function useTasksControllerRemoveAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError = unknown>(
 id: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerRemoveAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError = unknown>(
 id: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerRemoveAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError = unknown>(
 id: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove an attachment
 */

export function useTasksControllerRemoveAttachmentV1<TData = Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError = unknown>(
 id: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerRemoveAttachmentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerRemoveAttachmentV1QueryOptions(id,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerListCommentsV1Url = (id: string,) => {




  return `/v1/tasks/${id}/comments`
}

/**
 * @summary Comment threads, oldest first
 */
export const tasksControllerListCommentsV1 = async (id: string, options?: RequestInit): Promise<TaskCommentDto[]> => {

  return apiRequest<TaskCommentDto[]>(getTasksControllerListCommentsV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTasksControllerListCommentsV1QueryKey = (id: string,) => {
    return [
    `/v1/tasks/${id}/comments`
    ] as const;
    }


export const getTasksControllerListCommentsV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerListCommentsV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>> = ({ signal }) => tasksControllerListCommentsV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerListCommentsV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>>
export type TasksControllerListCommentsV1QueryError = unknown


export function useTasksControllerListCommentsV1<TData = Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerListCommentsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerListCommentsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerListCommentsV1<TData = Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerListCommentsV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerListCommentsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerListCommentsV1<TData = Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Comment threads, oldest first
 */

export function useTasksControllerListCommentsV1<TData = Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerListCommentsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerListCommentsV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerCreateCommentV1Url = (id: string,) => {




  return `/v1/tasks/${id}/comments`
}

/**
 * Mentions in the body raise `task.mentioned`.
 * @summary Comment, or reply to a top-level comment
 */
export const tasksControllerCreateCommentV1 = async (id: string,
    createTaskCommentDto: CreateTaskCommentDto, options?: RequestInit): Promise<TaskCommentDto> => {

  return apiRequest<TaskCommentDto>(getTasksControllerCreateCommentV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTaskCommentDto)
  }
);}





export const getTasksControllerCreateCommentV1QueryKey = (id: string,
    createTaskCommentDto?: CreateTaskCommentDto,) => {
    return [
    'POST', `/v1/tasks/${id}/comments`, createTaskCommentDto
    ] as const;
    }


export const getTasksControllerCreateCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError = unknown>(id: string,
    createTaskCommentDto: CreateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerCreateCommentV1QueryKey(id,createTaskCommentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>> = ({ signal }) => tasksControllerCreateCommentV1(id,createTaskCommentDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerCreateCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>>
export type TasksControllerCreateCommentV1QueryError = unknown


export function useTasksControllerCreateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError = unknown>(
 id: string,
    createTaskCommentDto: CreateTaskCommentDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerCreateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError = unknown>(
 id: string,
    createTaskCommentDto: CreateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerCreateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError = unknown>(
 id: string,
    createTaskCommentDto: CreateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Comment, or reply to a top-level comment
 */

export function useTasksControllerCreateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError = unknown>(
 id: string,
    createTaskCommentDto: CreateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerCreateCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerCreateCommentV1QueryOptions(id,createTaskCommentDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerUpdateCommentV1Url = (id: string,
    commentId: string,) => {




  return `/v1/tasks/${id}/comments/${commentId}`
}

/**
 * @summary Edit your own comment
 */
export const tasksControllerUpdateCommentV1 = async (id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options?: RequestInit): Promise<TaskCommentDto> => {

  return apiRequest<TaskCommentDto>(getTasksControllerUpdateCommentV1Url(id,commentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTaskCommentDto)
  }
);}





export const getTasksControllerUpdateCommentV1QueryKey = (id: string,
    commentId: string,
    updateTaskCommentDto?: UpdateTaskCommentDto,) => {
    return [
    'PATCH', `/v1/tasks/${id}/comments/${commentId}`, updateTaskCommentDto
    ] as const;
    }


export const getTasksControllerUpdateCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError = unknown>(id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerUpdateCommentV1QueryKey(id,commentId,updateTaskCommentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>> = ({ signal }) => tasksControllerUpdateCommentV1(id,commentId,updateTaskCommentDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && commentId !== null && commentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerUpdateCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>>
export type TasksControllerUpdateCommentV1QueryError = unknown


export function useTasksControllerUpdateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError = unknown>(
 id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerUpdateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError = unknown>(
 id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerUpdateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError = unknown>(
 id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Edit your own comment
 */

export function useTasksControllerUpdateCommentV1<TData = Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError = unknown>(
 id: string,
    commentId: string,
    updateTaskCommentDto: UpdateTaskCommentDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerUpdateCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerUpdateCommentV1QueryOptions(id,commentId,updateTaskCommentDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTasksControllerDeleteCommentV1Url = (id: string,
    commentId: string,) => {




  return `/v1/tasks/${id}/comments/${commentId}`
}

/**
 * @summary Delete a comment (author or owner)
 */
export const tasksControllerDeleteCommentV1 = async (id: string,
    commentId: string, options?: RequestInit): Promise<DeletedResponseDto> => {

  return apiRequest<DeletedResponseDto>(getTasksControllerDeleteCommentV1Url(id,commentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTasksControllerDeleteCommentV1QueryKey = (id: string,
    commentId: string,) => {
    return [
    'DELETE', `/v1/tasks/${id}/comments/${commentId}`
    ] as const;
    }


export const getTasksControllerDeleteCommentV1QueryOptions = <TData = Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError = unknown>(id: string,
    commentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTasksControllerDeleteCommentV1QueryKey(id,commentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>> = ({ signal }) => tasksControllerDeleteCommentV1(id,commentId, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && commentId !== null && commentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TasksControllerDeleteCommentV1QueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>>
export type TasksControllerDeleteCommentV1QueryError = unknown


export function useTasksControllerDeleteCommentV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError = unknown>(
 id: string,
    commentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerDeleteCommentV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError = unknown>(
 id: string,
    commentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>,
          TError,
          Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTasksControllerDeleteCommentV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError = unknown>(
 id: string,
    commentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a comment (author or owner)
 */

export function useTasksControllerDeleteCommentV1<TData = Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError = unknown>(
 id: string,
    commentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerDeleteCommentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTasksControllerDeleteCommentV1QueryOptions(id,commentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






